import React from 'react';
import universal from 'react-universal-component';

import { Spinner } from 'app/design-system/components/Spinner';

export default universal(() => import('./ExternalGameById'), {
  loading: () => <Spinner />,
});
